export default __webpack_public_path__ + "static/hong-395db409941252837d069ea2063a3dec.jpeg";